<template>
  <Content id="physicalProject">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="项目名称" :label-width="70"><Input v-model="search.name" maxlength="50"/></FormItem></Col>
          <Col><FormItem label="编码"><Input v-model="search.code" maxlength="100"/></FormItem></Col>
          <Col>
            <FormItem label="必填限制" :label-width="75">
              <Select v-model="search.isRequired" style="min-width: 90px;" :clearable="true">
                <Option v-for="item in isRequiredList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="业务类型" :label-width="75">
              <Select v-model="search.businessType" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in businessTypeList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="小程序显示" :label-width="85">
              <Select v-model="search.isShow" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in isShowList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="min-width: 75px;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
          <Button size="small" style="margin-left: 5px;" icon="ios-paper-outline" @click="handleCopy" type="primary">复制模版</Button>
        </div>
      </div>

    </div>

    <Row :gutter="24" class="tableCell" style="margin-bottom: 10px;margin-left: 2px;margin-right: 10px;">
      <Col class="col-cell" v-for="(item, index) in [24]" :span="item" style="border: #ffe8c5 solid 1px;height:35px;line-height:35px;background-color: #fff9f0;">
        <slot v-for="i in 1" :name="'inner'+i" v-if="(index+1) == i">
          <Icon type="ios-cube"/><span style="text-align: left;color: #f3673d;margin-right: 5px;"> 鼠标长按上下拖动可以调整排序</span>
        </slot>
      </Col>
    </Row>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="name" label="项目名称" min-width="80">
        <template slot-scope="{row}">{{ row.name }}</template>
      </el-table-column>
      <el-table-column align="center" prop="code" label="编码" min-width="100"/>
      <el-table-column align="center" prop="projectType" label="项目类型" min-width="80">
        <template slot-scope="{row}">
          {{ enums.projectTypes.filter(u => u.value === row.projectType)[0].label }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="price" label="价格" min-width="80"/>
      <el-table-column align="center" prop="type" label="小程序显示" min-width="80">
        <template slot-scope="{row}">
          {{ isShowList.filter(u => u.value === row.isShow)[0].label }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isRequired" label="必填限制" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.isRequired === 1 ? 'primary' : row.isRequired === 2 ? 'danger' : ''" disable-transitions>
            {{ row.isRequired == 1 ? '弹框提示' : row.isRequired == 2 ? '限制提交' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isPhysical" label="体检项目" min-width="80">
        <template slot-scope="{row}">{{ row.isPhysical == 1 ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" min-width="80">
        <template slot-scope="{row}">
          {{ enums.physicalProjectTypes.filter(u => u.value === row.type)[0].label }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="businessType" label="业务类型" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" type="success" disable-transitions>
            {{
              row.businessType ? (row.businessType == 1 ? '通用' : row.businessType == 2 ? '幼儿园' : row.businessType == 3 ? '小学' : row.businessType == 4 ? '中学' :  row.businessType == 5 ? '大学' : '') : ''
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="80"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="160"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作" min-width="80" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="dialogVisible" :title="dialogTitle" style="top:60px;text-align:center;" width="40%" :mask-closable="false" :max-height="maxHeight">
      <Row :gutter="24" class="tableCell" style="margin-bottom: 10px;margin-left: 2px;margin-right: 10px;">
        <Col class="col-cell" v-for="(item, index) in [24]" :span="item" style="border: #ffe8c5 solid 1px;height:35px;line-height:35px;background-color: #fff9f0;">
          <slot v-for="i in 1" :name="'inner'+i" v-if="(index+1) == i">
            <Icon type="ios-cube"/><span style="text-align: left;color: #f3673d;margin-right: 5px;"> 先配置字段再配置体检项目 </span>
          </slot>
        </Col>
      </Row>

      <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入" v-model="projectIds" :data="tempalteList" :titles="['选项', '已选择']"/>
      <div slot="footer">
        <Button @click="dialogVisible = false">取消</Button>
        <Button type="primary" @click="saveTempalte" :disabled="importDisabled">确定</Button>
      </div>
    </Modal>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <PhysicalProjectEdit  ref="edit" :style="{'max-height':maxHeight, 'overflow-y': 'auto'}" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_search, _updateStatus, _generalProject, _copyProject,_updateSort} from "@/services/screeningConfig/physicalProject.js";
import PhysicalProjectEdit from "./PhysicalProjectEdit";
import {enums} from "@/services/enums";
import Sortable from "sortablejs";
export default {
  name: "PhysicalProject",
  components: {
    PhysicalProjectEdit
  },
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex: null,
      search: {
        name: "",
        code: "",
        isRequired:"",
        businessType:"",
        isShow:"",
        status:1
      },
      projectIds:[],
      tempalteList:[],
      dialogTitle:"模版详情",
      dialogVisible: false,
      importDisabled: false,
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      isShowList:[
        {label: '显示', value: 1},
        {label: '不显示', value: 2},
      ],
      isRequiredList:[
        {label: '弹框提示', value: 1},
        {label: '限制提交', value: 2},
      ],
      businessTypeList:[
        {label: '通用', value: 1},
        {label: '幼儿园', value: 2},
        {label: '小学', value: 3},
        {label: '中学', value: 4},
        {label: '大学', value: 5},
      ],
      enums:enums,
      editWindow:false,
      windowTitle:"新增项目",
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.generalProject();

    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
    }

    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
      this.maxHeight = `${height - 300}px`;
    },
    generalProject(){
      this.tempalteList = [];
      _generalProject().then(res => {
        if (res.errcode === 1) {
          res.data.forEach((item, index) => {
            this.tempalteList.push({
              // label: item.name + (item.flag ? "(" + item.flag + ")" : ""),
              label: item.name + (item.businessType ? (item.businessType == 1 ? ' -- 通用' : item.businessType == 2 ? ' -- 幼儿园' : item.businessType == 3 ? ' -- 小学' : item.businessType == 4 ? ' -- 中学' :  item.businessType == 5 ? ' -- 大学' : '') : ''),
              key: item.id
            });
          });
        }else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    saveTempalte(){
      if(!this.projectIds||this.projectIds.length==0){
        this.$message.warning('请先选择');
        return;
      }

      this.importDisabled = true;
      _copyProject({projectIds:this.projectIds}).then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
          this.dialogVisible = false;
          this.importDisabled = false;
        }else {
          this.importDisabled = false;
          this.$message.error(res.errmsg);
        }
      }).catch(res=>{
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    handleCopy() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.importDisabled = false;
      this.dialogVisible = true;
      this.projectIds = [];

      /*_copyProject().then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
        }
      }).catch(() => {});*/
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.handleDataList();
    },
    handleDataList() {
      _search({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode === 1 && res.data) {
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        }
      }).catch(() => {});
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑体检项目";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(()=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch(() => {
              this.$Loading.error();
              this.list.loading = false;
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    rowDrop() {
      // const tbody = document.querySelector(".el-table__fixed-body-wrapper tbody");
      const table = this.$refs.singleTable.$el;
      // 主表格体
      const mainTbody = table.querySelector('.el-table__body-wrapper tbody');
      // 左侧固定列的表格体（如果存在）
      const fixedTbody = table.querySelector('.el-table__fixed-body-wrapper tbody');

      [mainTbody, fixedTbody].forEach(tbody => {
        if (tbody) {
          Sortable.create(tbody, {
            // boolean 定义是否此sortable对象是否可用，为true时sortable对象不能拖放排序等功能，为false时为可以进行排序，相当于一个开关；
            disabled: false,
            //拖拽动画(毫秒)
            animation: 600,
            ghostClass: 'sortable-ghost', // 拖拽时占位符的样式:cite[2]:cite[6]
            // 结束拖拽
            onEnd: ({ oldIndex, newIndex }) => {
              let data = [...this.dataList];
              const currRow = data.splice(oldIndex, 1)[0];
              data.splice(newIndex, 0, currRow);
              this.dataList = [];
              this.$nextTick(() => {
                this.dataList = data;
              });

              let updateData = data.map((item, index) => {
                item.sorts = this.pageList.pageSize * (this.pageList.currentPage - 1) +  (index + 1);
                return item;
              });

              this.updateSort(updateData);
              this.$forceUpdate();
            },
          });
        }
      });
    },
    updateSort(data) {
      _updateSort(data).then(res => {
        if(res && res.errcode == 1){
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {
      });
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-transfer-panel .el-transfer-panel__header {text-align: left;}
/deep/ .el-transfer-panel__list.is-filterable {text-align: left;}
/deep/ .el-transfer-panel {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background: #FFF;
  display: inline-block;
  vertical-align: middle;
  width: 250px;
  max-height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
</style>
